<cm-menu></cm-menu>
<app-loader-overlay></app-loader-overlay>
<div class="app__container">
  <router-outlet></router-outlet>
</div>
<div class="app__build-version-container">
  <storybook-build-version [version]="spaVersionId"></storybook-build-version>
</div>
